import React from 'react';
import { ProjectKeywordGq } from '../../../../../graphql/projects/models/ProjectKeywordGq';
import { formatNumber } from '../../../../../logic/otherUtilities/formatting/formatNumber';
import VoxelLoadingSpinner from '../../../../voxel/Animation/VoxelLoadingSpinner';
import VoxelDataTableCell from '../../../../voxel/DataTable/VoxelDataTableCell';

export interface TableCellVolume12monthsProps {
  keyword: ProjectKeywordGq;
  monthVolume: number;
  yearVolume: number;
}

const TableCellVolume12months: React.FC<TableCellVolume12monthsProps> = React.memo(
  ({ keyword, monthVolume, yearVolume }) => {
    if (keyword.fetchingNewVolume)
      return (
        <VoxelDataTableCell align="right">
          <div className="flex flex-row justify-center items-center">
            <VoxelLoadingSpinner />
          </div>
        </VoxelDataTableCell>
      );

    const colorsList = [
      'bg-gradient-to-tr from-white to-voxel-green-50',
      'bg-gradient-to-tr from-voxel-green-50 to-voxel-green-100',
      'bg-gradient-to-tr from-voxel-green-100 to-voxel-green-200',
      'bg-gradient-to-tr from-voxel-green-200 to-voxel-green-300',
      'bg-gradient-to-tr from-voxel-green-300 to-voxel-green-400',
      'bg-gradient-to-tr from-voxel-green-500 to-voxel-green-600',
      'bg-gradient-to-tr from-voxel-green-600 to-voxel-green-700',
    ];

    // There's 10 colors per scale, index 0-9
    let color = '';
    if (monthVolume <= yearVolume / 24) {
      color = colorsList[0];
    } else if (monthVolume > yearVolume / 24 && monthVolume <= yearVolume / 20) {
      color = colorsList[1];
    } else if (monthVolume > yearVolume / 20 && monthVolume <= yearVolume / 16) {
      color = colorsList[2];
    } else if (monthVolume > yearVolume / 16 && monthVolume <= yearVolume / 12) {
      color = colorsList[3];
    } else if (monthVolume > yearVolume / 12 && monthVolume <= yearVolume / 8) {
      color = colorsList[4];
    } else if (monthVolume > yearVolume / 8 && monthVolume <= yearVolume / 4) {
      color = colorsList[5];
    } else if (monthVolume > yearVolume / 4) {
      color = colorsList[6];
    }

    return (
      <VoxelDataTableCell className={color} align="right">
        {formatNumber(monthVolume)}
      </VoxelDataTableCell>
    );
  }
);

export default TableCellVolume12months;
